
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

const config = {
  name: 'c-image'
}

@Component(config)
export default class Image extends Vue {

  @Prop({ type: String, required: true }) src!: string
  @Prop({ type: String, required: false }) srcset!: string
  @Prop({ type: String, required: false }) sizes!: string
  @Prop({ type: String, required: false, default: '' }) alt!: string
  @Prop({ type: Number, required: false }) widthRatio!: number
  @Prop({ type: Number, required: false }) heightRatio!: number
  @Prop({ type: String, required: false }) width!: string
  @Prop({ type: String, required: false }) height!: string
  @Prop({ type: Boolean, required: false, default: false }) lazy!: boolean
  @Prop({ type: String, required: false }) background!: string
  @Prop({ type: Boolean, required: false }) cover!: boolean
  @Prop({ type: Boolean, required: false }) contain!: boolean
  @Prop({ type: Number, default: 0 }) delay!: number

  isLoading: boolean = true
  isLoaded: boolean = false
  error: boolean = false
  display: boolean = true
  elWidth: number = 0
  retry: number = 0

  @Watch('src')
  onSrcUpdate () {
    this.init()
  }

  init () {
    this.elWidth = this.$el.clientWidth
    this.isLoading = true
    this.isLoaded = false
    this.retry = 0
    this.error = false
    this.display = true
  }

  mounted () {
    this.init()
  }

  get containerRatio () {
    const { widthRatio, heightRatio } = this
    if (!widthRatio || !heightRatio) return
    return 100 / (widthRatio / heightRatio)
  }

  get containerInlineStyle () {
    return {
      width: this.width,
      height: this.height,
      paddingBottom: this.containerRatio ? `${this.containerRatio}%` : null,
      background: this.background
    }
  }

  get overlayInlineStyle () {
    return {
      background: this.background
    }
  }

  get containerClasses () {
    return {
      'with-ratio': !!this.containerRatio,
      'is-loaded': this.isLoaded,
    }
  }

  get imageElementInlineStyle () {
    return {
      objectFit: this.cover ? 'cover' : null ||
                 this.contain ? 'contain' : null,
    }
  }

  get containerWidth () {
    return `${this.elWidth}px`
  }

  onImageLoad () {
    setTimeout(() => {
      this.isLoading = false
      this.isLoaded = true
      this.error = false
    }, this.delay)
  }

  onImageError (e: any) {
    this.display = false
    this.isLoading = true
    this.isLoaded = false
    this.error = true
    if (this.retry > 2) return
    this.retry++
    setTimeout(() => {
      this.display = true
    }, 1000)  
  }

  get loadingType () {
    return this.lazy ? 'lazy' : 'eager'
  }

}
